export const toneIconClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-700 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export const toneBadgeClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-700 border-accent-200",
  secondary: "bg-secondary-100 text-secondary-800 border-secondary-200",
};

export const toneSoftClass: Record<string, string> = {
  primary: "bg-primary-50",
  accent: "bg-accent-50",
  secondary: "bg-secondary-50",
};